// extracted by css-extract-rspack-plugin
export default {"actionListOverrides":"RelationshipsSection-module__actionListOverrides__ocVPsfz","groupHeading":"RelationshipsSection-module__groupHeading__HnUfEBa"};